import type {
    FC
} from "react";
import type IQuestionnaireDescriptionProps from "./type";
import type {
    QuestionnaireItemPartContentProps
} from "../../type";
import {
    withQuestionnaireItemContext
} from "../../context";
import Text from "../../../text";

const QuestionnaireDescriptionContent: FC<QuestionnaireItemPartContentProps<IQuestionnaireDescriptionProps>> = ({
    customTheme: customThemeProp,
    itemContext,
    children,
    context,
    ...props
}) => {
    const content = children ?? itemContext.item.description;

    if(!content) {
        return null;
    }

    return <Text
        {...props}
        customTheme={customThemeProp ?? context.customTheme}
        id={itemContext.descriptionId}
        variant="bodyMediumSize"
        color="mid"
    >
        {content}
    </Text>;
};
export default withQuestionnaireItemContext("Description", QuestionnaireDescriptionContent);
